import * as React from "react";
import classnames from "classnames";
import { MediaQuery, Util, Logo } from "@grandvisionhq/common";
import { Icon } from "@grandvisionhq/icons";
import { SearchBar } from "@grandvisionhq/search";
import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
import LocaleSelectOverlay from "../../LocaleOverlay/LocaleOverlay/LocaleSelectOverlay.js";
import { HeaderMenu } from "../HeaderMenu/Header/HeaderMenu/HeaderMenu.js";
/* empty css            */
const Header = ({
  renderCartButton,
  renderWishlistMenuItem,
  availableLocales,
  algoliaHeaderConfig,
  menuItems,
  myAccountButton,
  logo,
  logoMobile,
  logoLink,
  pageRoutes,
  onSubmit,
  isPreview,
  countrySwitcherOptions,
  children,
  shouldRenderSiteNav = true,
  hasOnlyLogo = false,
  siteName,
  className,
  ordersUrl
}) => {
  const [searchHasFocus, setSearchHasFocus] = React.useState(false);
  const { getLabel } = useIntl();
  const { isMultilingualEnabled } = useFeatureToggles();
  const openSiteNavEvent = React.useRef();
  const currentBreakpoint = MediaQuery.useBreakpoint();
  const isMobile = currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.PHONE;
  const { isHidden, isCondensedHeader, headerRef } = Util.useHeaderOnScroll(isMobile);
  React.useEffect(() => {
    openSiteNavEvent.current = Util.createCustomEvent("sitenav.open");
  }, []);
  const headerClasses = classnames("header__header", {
    "header__header--hidden": isHidden && isMobile,
    "header__header--search-has-focus": searchHasFocus
  });
  const showMultilingualComponents = !hasOnlyLogo && isMultilingualEnabled && !isPreview && !!availableLocales && availableLocales.length > 1;
  const logoLinkPath = logoLink ? logoLink : pageRoutes?.root || "/";
  const logoTitle = siteName ? `${siteName} home` : "Home";
  const handleFocus = React.useCallback(() => {
    setSearchHasFocus(true);
  }, []);
  const handleClose = React.useCallback(() => {
    setSearchHasFocus(false);
  }, []);
  const tealiumAttributesHeader = {
    "data-element-id": `MainNav`
  };
  const tealiumAttributesLogo = {
    "data-element-id": `MainNav_Logo`
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames("header", className, {
        "is-header-condensed": isCondensedHeader
      })
    },
    /* @__PURE__ */ React.createElement("header", { className: headerClasses, role: "banner", ref: headerRef }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classnames("site-container header__container", {
          "header__container--center": hasOnlyLogo
        })
      },
      !hasOnlyLogo && shouldRenderSiteNav && /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "header__hamburger",
          onClick: toggleSiteNav,
          type: "button",
          "aria-label": getLabel("common.menu.open"),
          ...tealiumAttributesHeader
        },
        /* @__PURE__ */ React.createElement(Icon, { name: "hamburger" })
      ),
      /* @__PURE__ */ React.createElement("div", { className: "header__logo-wrapper" }, /* @__PURE__ */ React.createElement(
        Logo,
        {
          className: isMobile ? "header__logo--mobile" : "header__logo",
          url: logoLinkPath,
          image: isMobile ? logoMobile : logo,
          title: logoTitle,
          tealiumAttributes: tealiumAttributesLogo
        }
      )),
      !hasOnlyLogo && /* @__PURE__ */ React.createElement(React.Fragment, null, isMobile && renderSearchBar(), /* @__PURE__ */ React.createElement(
        HeaderMenu,
        {
          renderCartButton,
          renderWishlistMenuItem,
          showMultilingualComponents,
          availableLocales,
          myAccountButton,
          menuItems,
          toggleMobileSearch: handleFocus,
          countrySwitcherOptions,
          ordersUrl
        }
      ), !isMobile && renderSearchBar())
    )),
    showMultilingualComponents && /* @__PURE__ */ React.createElement(
      LocaleSelectOverlay,
      {
        logo: logoMobile ? logoMobile : logo,
        availableLocales: availableLocales ?? []
      }
    ),
    children
  );
  function toggleSiteNav() {
    openSiteNavEvent.current && window.dispatchEvent(openSiteNavEvent.current);
  }
  function renderSearchBar() {
    if (!algoliaHeaderConfig) {
      return null;
    }
    const { apiKey, appId } = algoliaHeaderConfig;
    if (!apiKey || !appId || !onSubmit) {
      return null;
    }
    const searchClassName = classnames("header__search", {
      "header__search--mobile": isMobile,
      "header__search--desktop": !isMobile,
      "header__search--focus": searchHasFocus,
      "header__search--condensed": isCondensedHeader
    });
    return /* @__PURE__ */ React.createElement("div", { className: searchClassName, role: "search" }, /* @__PURE__ */ React.createElement(
      SearchBar,
      {
        pageRoutes,
        onSubmit,
        config: algoliaHeaderConfig,
        onFocus: handleFocus,
        onClose: handleClose,
        forceFocus: searchHasFocus,
        isMobile
      }
    ));
  }
};
export {
  Header,
  Header as default
};
//# sourceMappingURL=Header.js.map
